import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Spinner_svg__spinner",
  viewBox: "0 0 70 70"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      class: "Spinner_svg__path",
      cx: "35",
      cy: "35",
      fill: "none",
      r: "20",
      stroke: "#fff",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }